let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Eu7W")).then(() => parcelRequire('6Dqb4'));